export default {
  product_info: 'Produktinfo',
  return: 'Tilbage til valgmuligheder',
};
